import routes from '@/modules/property/property-routes';
import store from '@/modules/property/property-store';

export default {
  routes,
  store
};
